<template>
    <div class="turquoise-created-alert">
        <button @click.prevent="close" class="close" aria-label="Close">
            <SvgsClose />
        </button>
        <div>
            <h2 class="turquoise-alert-headline">My Itinerary deleted: <span>{{ name }}</span></h2>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        name: {
            type: String,
            required: true,
            default: '',
        },
    });
    const { name } = toRefs(props);

    const emit = defineEmits(['closeAlert']);
    function close() {
        emit('closeAlert');
    }

    onMounted(() => {
        setTimeout(() => {
            close();
        }, 3000);
    });
</script>

<style lang="scss" scoped>
    .turquoise-created-alert {
        z-index: $zStepTwo;
        position: absolute;
        top: 15px;
        right: 15px;
        left: 15px;
        padding: 30px;
        background-color: $turquoise;
        text-align: center;

        .turquoise-alert-headline {
            margin-bottom: 10px;
        }

        .close {
            position: absolute;
            top: 10px;
            right: 15px;
        }
    }
</style>
